/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Standalone_Field_TitleInputs */

const cs_social_standalone_field_title = /** @type {(inputs: Social_Standalone_Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadpis`)
};

const en_social_standalone_field_title = /** @type {(inputs: Social_Standalone_Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headline`)
};

/**
* | output |
* | --- |
* | "Headline" |
*
* @param {Social_Standalone_Field_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_standalone_field_title = /** @type {((inputs?: Social_Standalone_Field_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Standalone_Field_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_standalone_field_title(inputs)
	return cs_social_standalone_field_title(inputs)
});